import React from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, Puzzle, LifeBuoy, Languages, Check, ArrowRight } from "lucide-react";

const portfolio = [
  {
    icon: <Briefcase size={20} />,
    title: "Professional Services",
    body: "Expert consulting and implementation services to maximize the value of your technology investments.",
    items: ["Strategic Planning & Consulting", "Implementation & Deployment", "Training & Knowledge Transfer", "Best Practices & Optimization"],
    cls: "",
  },
  {
    icon: <Puzzle size={20} />,
    title: "Customized Integrations",
    body: "Seamless integration of diverse systems and platforms tailored to your existing infrastructure.",
    items: ["API Development & Integration", "Legacy System Modernization", "Third-Party Software Integration", "Custom Middleware Solutions"],
    cls: "green",
  },
  {
    icon: <LifeBuoy size={20} />,
    title: "Technical Support",
    body: "Comprehensive 24/7 technical support ensuring your systems run smoothly with minimal downtime.",
    items: ["24/7 Help Desk Support", "Remote & On-site Assistance", "Preventive Maintenance", "Incident Management & Resolution"],
    cls: "red",
  },
  {
    icon: <Languages size={20} />,
    title: "Regional Software Adaptations",
    body: "Localization and adaptation of software to meet regional requirements and compliance standards.",
    items: ["Regional Compliance & Regulations", "Localization & Translation", "Currency & Time Zone Adaptation", "Regional Feature Customization"],
    cls: "",
  },
];

export default function Portfolio() {
  const navigate = useNavigate();
  const goContact = () => navigate("/contact");

  return (
    <section id="portfolio" data-testid="portfolio-section" className="snap-section">
      <div className="max-w-[1280px] mx-auto px-6 w-full">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div className="max-w-3xl">
            <div className="section-eyebrow">Professional Services</div>
            <h2 className="section-title" data-testid="portfolio-title">
              Comprehensive Service Portfolio
            </h2>
            <p className="section-subtitle" data-testid="portfolio-subtitle">
              End-to-end professional services — from consultation to implementation and beyond.
            </p>
          </div>
          <button data-testid="portfolio-cta" onClick={goContact} className="btn-primary shrink-0 hidden md:inline-flex" style={{ padding: "12px 22px", fontSize: 14 }}>
            Get in Touch <ArrowRight size={16} />
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {portfolio.map((p, i) => (
            <div key={p.title} data-testid={`portfolio-card-${i}`} className="glass-card p-5 flex flex-col">
              <div className={`svc-icon ${p.cls} mb-4`} style={{ width: 42, height: 42 }}>{p.icon}</div>
              <h3 className="text-white text-lg font-semibold mb-2" style={{ fontFamily: "Sora, sans-serif" }}>{p.title}</h3>
              <p className="text-[#a6b3c8] text-[13px] leading-relaxed mb-4">{p.body}</p>
              <ul className="space-y-1.5 mt-auto">
                {p.items.map((item) => (
                  <li key={item} className="flex items-start gap-2 text-[#c8d4ea] text-[12.5px]">
                    <Check size={13} className="mt-1 shrink-0 text-[#6bd6bd]" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <button
          data-testid="portfolio-cta-mobile"
          onClick={goContact}
          className="btn-primary md:hidden w-full justify-center mt-6"
        >
          Get in Touch <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
}
